import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { UserMenu } from "@/components/UserMenu";
import { Home, Wallet, CalendarHeart, BookOpen, Settings, LogOut, Crown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Mascot } from "@/components/Mascot";

const NAV = [
  { to: "/", label: "Beranda", icon: Home, id: "home" },
  { to: "/duitku", label: "Duitku", icon: Wallet, id: "duitku" },
  { to: "/mood", label: "Mood Aku", icon: CalendarHeart, id: "mood" },
  { to: "/baca", label: "Baca Yuk", icon: BookOpen, id: "baca" },
  { to: "/pengaturan", label: "Akunku", icon: Settings, id: "settings" },
];

const TopBar = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b border-pink-100">
      <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
        <NavLink to="/" className="flex items-center gap-2" data-testid="brand-link">
          <Mascot pose="happy" className="w-10" float={false} />
          <span className="font-heading text-2xl font-semibold text-pink-500">windiku<span className="text-sky-400">.com</span></span>
        </NavLink>
        <div className="flex items-center gap-2">
          <button onClick={() => setOpen(true)} data-testid="current-user-badge" className="chip chip-off !py-1 text-xs">
            {user.role === "master" && <Crown className="w-3.5 h-3.5 text-amber-400" />}
            {user.name}
          </button>
          <UserMenu open={open} onClose={() => setOpen(false)} />
          <button data-testid="logout-btn" onClick={logout} className="p-2 rounded-full text-pink-400 hover:bg-pink-50" aria-label="Keluar">
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
};

const BottomNav = () => (
  <nav className="fixed bottom-3 inset-x-0 z-30 px-3">
    <div className="max-w-md mx-auto bg-white/90 backdrop-blur-xl border border-pink-100 rounded-full shadow-lg shadow-pink-200/50 flex justify-between px-2 py-1.5">
      {NAV.map(({ to, label, icon: Icon, id }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          data-testid={`nav-${id}`}
          className={({ isActive }) =>
            `flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-full text-[11px] font-medium transition-colors ${
              isActive ? "bg-pink-500 text-white" : "text-pink-400 hover:bg-pink-50"
            }`
          }
        >
          <Icon className="w-5 h-5" />
          {label}
        </NavLink>
      ))}
    </div>
  </nav>
);

export default function Layout() {
  return (
    <div className="min-h-screen bg-dots">
      <TopBar />
      <main className="max-w-5xl mx-auto px-4 pt-6 pb-32">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
